<div
  class="combined-header"
  [class.production]="globals.isProduction"
  [class.header-hidden]="headerVisible === false"
>
  <mat-toolbar #header class="fixed-header">
    <div class="info-container">
      @if (!caseHeader) {
        <span class="header-title">
        <ng-content select="header-title"></ng-content>
      </span>
      }

      @if (caseHeader) {
        <div class="case-header">
          <a class="header-title header-link" (click)="viewClient()">{{ displayName }}</a>
          @if (['OW', 'ODSP'].indexOf(incomeSourceCode) !== -1) { <span> {{ incomeSourceCode | transloco}} &nbsp;</span> }
          <span>
            {{ caseCodeName }}
          </span>
          @if (caseEmail != null) {
            <div>
              <span class="email">
                <a href="mailto:{{ caseEmail }}" aria-label="Email client">
                  <img class="email" ngSrc="assets/images/envelope-regular.svg" alt="email" height="16" width="16"/>
                </a>
              </span>
            </div>
          }
          <span class="business-key">{{ clientClientBusinessKey2 }}</span>
        </div>
      }
    </div>

    <div class="button-container">
      <cf2-search-input
        *ngIf="search"
        class="search search-margin"
        #searchInput
        [ctrl]="_containerCtrl"
        (keyup)="keyupEvent($event.target.value)"
      ></cf2-search-input>

      <span class="menu">
        <ng-content select="[slot='three']"></ng-content>
      </span>
      <span class="menu">
        <ng-content select="[slot='two']"></ng-content>
      </span>
      <span class="menu" [class.menu-noSearch]="search === false">
        <ng-content select="[slot='one']"></ng-content>
      </span>
      <span class="menu-filter" [class.filter-hidden]="drawer === false" [class.menu-noSearch]="search === false">
        <app-icon-button
          [on]="drawerIcons[0]"
          [off]="drawerIcons[1]"
          (click)="isDrawerActive = !isDrawerActive && !disableDrawerIcons"
          [disabled]="disableDrawerIcons"
        >
        </app-icon-button>
      </span>
    </div>
  </mat-toolbar>

  <div #pinnedContent class="pinned-content">
    <ng-content select="pinned-content"></ng-content>
  </div>
</div>

<div #pageContainer class="page-container">
  @if (isLoading) {
    <div class="overlay">
      <div class="spinner-wrapper"></div>
    </div>
  }

  <div #pageContent class="page-content-container">
    <ng-content select="page-content"></ng-content>
  </div>

  <!-- filter drawer -->
  <div #filter class="sub-drawer-inactive" [class.sub-drawer-active]="isDrawerActive">
    <ng-content select="drawer-content"></ng-content>
  </div>
</div>

<!-- <div class="combined-header" [class.header-hidden]="headerVisible === false">
  <mat-toolbar #header class="fixed-header">
    <div class="info-container">
      <span class="header-title" *ng_If="!caseHeader">
        <ng-content select="header-title"></ng-content>
      </span>

      <div class="case-header" *ng_If="caseHeader">
        <a class="header-title header-link" (click)="viewClient()">{{ displayName }}</a>
        <span>{{ caseCodeName }}</span>
        <span class="business-key">{{ clientBusinessKey }}</span>
      </div>
    </div>

    <div class="button-container">
      <cf2-search-input *ng_If="search" class="search" #searchInput [ctrl]="ctrl"
                        (keyup)="keyupEvent($event.target.value)">
      </cf2-search-input>

      <span class="menu">
        <ng-content select="[slot='three']"></ng-content>
      </span>
      <span class="menu">
        <ng-content select="[slot='two']"></ng-content>
      </span>
      <span class="menu" [class.menu-noSearch]="search === false">
        <ng-content select="[slot='one']"></ng-content>
      </span>
      <span class="menu-filter" [class.filter-hidden]="drawer === false" [class.menu-noSearch]="search === false">
        <app-icon-button [on]="drawerIcons[0]" [off]="drawerIcons[1]"
                         (click)="isDrawerActive = !isDrawerActive && !disableDrawerIcons" [disabled]="disableDrawerIcons">
        </app-icon-button>
      </span>
    </div>
  </mat-toolbar>

  <div #pinnedContent class="pinned-content">
    <ng-content select="pinned-content"></ng-content>
  </div>
</div>

<div #pageContainer class="page-container">
  <div class="overlay" *ng_If="isLoading">
    <div class="spinner-wrapper"></div>
  </div>

  <div #pageContent class="page-content-container">
    <ng-content select="page-content"></ng-content>
  </div>

  <div #filter class="sub-drawer-inactive" [class.sub-drawer-active]="isDrawerActive">
    <ng-content select="drawer-content"></ng-content>
  </div>
</div> -->